import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AlgChannelService} from "./channel.service";
import { Core2Config } from '../../../shared';

@Injectable({providedIn: "root"})
export class InstagramChat extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'instagram-chat/send';
    this.endpointPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'instagram-chat/send';
    this.httpClient = httpClient;
  }

}
